import React from 'react';
import { makeStyles } from '@material-ui/core';

type Props = {
  text: string;
  colSize?: number;
};

const useStyles = makeStyles(() => ({
  message: {
    width: '100%',
    display: 'inline-block',
  },
}));

const Message = ({ text, colSize }: Props) => {
  const classes = useStyles();
  return (
    <tr>
      <td colSpan={colSize} className={colSize ? '' : classes.message}>
        <div style={{ textAlign: 'center' }}>
          <span data-cy="message">{text}</span>
        </div>
      </td>
    </tr>
  );
};

export default Message;
